
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";

interface QuoteNotesFieldProps {
  control: Control<any>;
  isLoading: boolean;
}

const QuoteNotesField: React.FC<QuoteNotesFieldProps> = ({
  control,
  isLoading
}) => {
  return (
    <FormField
      control={control}
      name="notes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Notes</FormLabel>
          <FormControl>
            <Textarea placeholder="Additional notes" {...field} disabled={isLoading} rows={3} />
          </FormControl>
          <FormDescription>
            Any additional notes about this quote.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default QuoteNotesField;
